import { useGetAnalysisByTokenQuery } from 'generated/graphql';
import { useState } from 'react';
import useParseSavedSlugInfo from 'v2/core/services/savedSlug/useParseSavedSlugInfo';
import { useGetUser } from 'v2/core/services/user';

export const useUpdateScheduleDataInStore = () => {
  const { token } = useParseSavedSlugInfo();

  const {
    id: userID,
    tenant: { id: tenantID },
  } = useGetUser();

  const [shouldFetchSearchDashboard, setShouldFetchSearchDashboard] =
    useState(false);

  const onFetchDashboardSuccessCallback = () => {
    setShouldFetchSearchDashboard(false);
  };

  const { loading } = useGetAnalysisByTokenQuery({
    variables: {
      token: token ?? '',
      tenantID,
      userID,
      includeScheduleOutbounds: true,
    },
    onCompleted: onFetchDashboardSuccessCallback,
    skip: !token || !shouldFetchSearchDashboard,
    fetchPolicy: 'network-only',
  });

  return {
    updateScheduleDataInStore: () => setShouldFetchSearchDashboard(true),
    loading,
  };
};
